import React from "react";

const DOCBadge = () => {
  return (
    <div
      style={{
        background: "#4A79E8",
        color: "white",
        padding: "6px 14px",
        borderRadius: "8px",
        fontSize: "12px",
        fontWeight: 600,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "fit-content"
      }}
    >
      DOC
    </div>
  );
};

export default DOCBadge;
